module.exports = __webpack_public_path__ + "img/eh.3b662831.svg";